import { ReoButton as ReolinkButton }  from '@reolink-deps/reolink-web_components.basic';
import { ReoButton as CamovueButton }  from '@camovue-deps/reolink-web_components.basic';
import type { IReoButtonProps as IReolinkButtonProps }  from '@reolink-deps/reolink-web_components.basic';
import type { IReoButtonProps as ICamovueButtonProps }  from '@camovue-deps/reolink-web_components.basic';

const Button = __MERCHANT__ === 'reolink' ? ReolinkButton : CamovueButton;

export type IReoButtonProps = IReolinkButtonProps | ICamovueButtonProps;
export default Button;
